import type * as React from 'react';

import { compose, withProps } from 'recompose';

import withDegreeAndMastertrackLists from 'bundles/browse/components/Domain/withDegreeAndMastertrackLists';
import { ProductVariantNames } from 'bundles/browse/constants';
import type { DegreeProductMember } from 'bundles/browse/types/degree-list';

type PropsFromDegreeList = {
  degreeList: DegreeProductMember[];
  loading: boolean;
};

type FromWithProps = {
  degreesForCollectionCarousel: { degree: DegreeProductMember; __typename: 'DegreeListsV3' }[];
};

export type Props = PropsFromDegreeList & FromWithProps;

const withDegreeRecommendationData = <InnerProps extends Props, OuterProps extends {}>(
  WrappedComponent: React.ComponentType<InnerProps>
) =>
  compose<InnerProps, OuterProps>(
    withDegreeAndMastertrackLists(() => {
      const domains = null;
      const productVariants = [
        ProductVariantNames.BachelorsDegree,
        ProductVariantNames.MastersDegree,
        ProductVariantNames.PostgraduateDiploma,
        ProductVariantNames.Mastertrack,
      ];
      return { domains, productVariants };
    }),
    withProps<FromWithProps, PropsFromDegreeList>(({ degreeList }) => {
      return {
        degreesForCollectionCarousel: degreeList?.map((degree) => ({ degree, __typename: 'DegreeListsV3' })),
      };
    })
  )(WrappedComponent);

export default withDegreeRecommendationData;
